<template>
  <div class="col-md-4">
    <div class="form-group">
      <label>{{label}}<span class="required">*</span>
    </label>
      <div class="row">
        <div class="col-md-4" style="padding-right:0px;" v-for="(field, index) in schema">
          <div class="form-group">       
            <input type="text" class="form-control"
                   :name="field.name" v-only-text-number
                     v-model="value[field.name]" v-validate="'required'" :maxlength="field.length"
                   :placeholder="placeholder" v-only-uppercase/>
            <div v-show="errors.has(field.name)" class="help is-danger">{{ field.required_message }}</div>
          </div>
        
        </div>
      </div>
  </div>
  </div>
</template>
<script>
  export default {
  name: 'COMBINE',
  inject: ['$validator'],
  props: ['schema','value','label']
  }
</script>


